<div id="profile" class="watermark">
    <div class="container-fluid px-lg-5">
        <div class="row">
            <div class="col-12">
                <h2 class="title">Feedback</h2>
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img src="/assets/img/governing/1.jpg" alt="" class="img-fluid"> -->
                        <pdf-viewer src='/assets/pdf/iqac/feedback-2023-24.pdf' [render-text]="true" [original-size]="false"
                            style="width: 100%; height: 680px; position: relative;" class="mb-4"></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>